import { OPERATING_MODELS } from "./data/content";
import Reveal from "./Reveal";
import PhotoSlot from "./PhotoSlot";

export const Story = () => (
  <section id="how" className="py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-14 lg:grid-cols-2 lg:gap-20">
        <div>
          <Reveal>
            <p className="label-mono">The Agency HQ story</p>
            <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
              Not a franchise. Not a licence. A platform built for agents.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="mt-7 space-y-5 text-base leading-relaxed text-slate-400">
              <p>
                Traditional franchises take a share of every sale and hand you a rulebook. Going fully
                independent hands you the whole agency problem — licences, trust accounts, compliance,
                payroll.
              </p>
              <p>
                Agency HQ is neither. It is a central operating platform that helps agents establish,
                manage and grow their own businesses — while keeping their identity and a greater share
                of what they earn.
              </p>
              <p className="text-slate-300">
                You focus on relationships, listings and sales. Our experienced team manages everything
                behind the transaction.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15} className="mt-9">
            <PhotoSlot
              file="story-office.jpg"
              label="Agency HQ people and events — drop a real photo here (images/story-office.jpg)"
              aspect="aspect-[16/10]"
            />
          </Reveal>
        </div>

        <div className="flex flex-col justify-center gap-4">
          <Reveal>
            <p className="label-mono mb-4">Three ways to operate</p>
          </Reveal>
          {OPERATING_MODELS.map((m, i) => (
            <Reveal key={m.tag} delay={0.08 * (i + 1)}>
              <div
                className="group rounded-2xl border border-white/10 bg-panel/60 p-6 transition-all duration-200 hover:-translate-y-1 hover:border-gold/40 sm:p-8"
                data-testid={`operating-model-${m.tag}`}
              >
                <div className="flex items-start gap-5">
                  <span className="font-mono text-sm font-semibold text-gold-light">{m.tag}</span>
                  <div>
                    <h3 className="font-display text-xl font-semibold tracking-tight text-white">{m.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-400">{m.desc}</p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Story;
